import { RenderMediaContent } from "src/components/RenderMediaContent"
import custom_button_text from '../../assets/setup/custom_button_text.m4v';

// component props interface 
interface Props {
    isMobileView: boolean;
}

export const CustomButtonText: React.FC<Props> = ({ isMobileView }) => {
    return (
        <div className="flex flex-col justify-center gap-y-4">
            <div>
            <p>Customize button text color, style, weight, and more.</p>
            <p className="mt-4"><strong>1. Use Deck Hopper Advanced extension</strong></p>
                <p>Please ensure you have <strong><a href="https://christinak.itch.io/deck-hopper-advanced">Deck Hopper Advanced</a></strong> extension installed and running. Inside the premade deck, use "Customize Button" button to automatically generate the JSON.</p>
            </div>

            {<RenderMediaContent src={custom_button_text} />}
            
            <div>
                <p><strong>2. Or manually add the JSON to the button:</strong></p>
                <ol className="flex flex-col gap-y-2 list-decimal list-inside mb-5">
                    <li>If the button is not persistent, switch it to persistent temporarily, then revert to non-persistent.</li>
                    <li>
                        Insert the following object into the init variables of that button: <code>dh_styles</code>. Inside the object, you can add the following keys:
                        <ul className="flex flex-col gap-y-2 list-disc list-inside ms-8 ">
                            <li><code>dh_text_color</code> - accepts either an HTML color (for example blue) or hex color (for example #e02482).</li>
                            <li><code>dh_text_shadow</code> - add this key to remove the text shadow (value doesn't matter).</li>
                            <li><code>dh_align</code> - add this key to align the text, accepts the following values: right, left, center (default).</li>
                            <li><code>dh_font_weight</code> - add this key to change the font weight, accepts the following values: normal, bold (default), bolder, lighter.</li>
                            <li><code>dh_font_style</code> - add this key to change the font style, accepts the following values: normal (default), italic, oblique.</li>
                        </ul>
                    </li>
                </ol>


                <p>Example JSON:</p>
                <pre>{`{
    "dh_styles": {
        "dh_font_style": "Italic",
        "dh_font_weight": "Normal",
        "dh_text_color": "#2d81ff",
        "dh_align": "Left"
    }
}`}</pre>
            </div>
            <div>
                <strong> Useful to know:</strong>
                <ul className="flex flex-col gap-y-2 list-disc list-inside">
                    <li>You don’t need to initialize the init variables beforehand.</li>
                    <li>The init variables inside the button don’t need to exist.</li>
                    <li>The button doesn’t need to be persistent for the changes to apply.</li>
                </ul>
            </div>
        </div>
    );
}